import { actionTypes } from "./actions";

const initialState = {
  data: [],
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.SELLOUT_SET_FILE_PENDING_APPROVALS:
      return {
        ...state,
        data: payload,
      };

    default:
      return {
        ...state,
      };
  }
};
